import { AgendaModel } from "@services/all.services";

// Types d'actions
export const AGENDA_MODEL_LIST_REQUEST = "AGENDA_MODEL_LIST_REQUEST";
export const AGENDA_MODEL_LIST_SUCCESS = "AGENDA_MODEL_LIST_SUCCESS";
export const AGENDA_MODEL_LIST_FAILURE = "AGENDA_MODEL_LIST_FAILURE";

export const AGENDA_MODEL_CREATE_REQUEST = "AGENDA_MODEL_CREATE_REQUEST";
export const AGENDA_MODEL_CREATE_SUCCESS = "AGENDA_MODEL_CREATE_SUCCESS";
export const AGENDA_MODEL_CREATE_FAILURE = "AGENDA_MODEL_CREATE_FAILURE";

export const AGENDA_MODEL_UPDATE_REQUEST = "AGENDA_MODEL_UPDATE_REQUEST";
export const AGENDA_MODEL_UPDATE_SUCCESS = "AGENDA_MODEL_UPDATE_SUCCESS";
export const AGENDA_MODEL_UPDATE_FAILURE = "AGENDA_MODEL_UPDATE_FAILURE";

export const AGENDA_MODEL_DELETE_REQUEST = "AGENDA_MODEL_DELETE_REQUEST";
export const AGENDA_MODEL_DELETE_SUCCESS = "AGENDA_MODEL_DELETE_SUCCESS";
export const AGENDA_MODEL_DELETE_FAILURE = "AGENDA_MODEL_DELETE_FAILURE";

const AgendaModelRules = [
  "hoursBuild",
  "workingHoursSettingsSectionHourModels"
];

// Thunks (actions asynchrones)
export const getAgendaModelByEnterprise = (params) => async (dispatch) => {
  dispatch({ type: AGENDA_MODEL_LIST_REQUEST });
  try {
    const data = await AgendaModel.getByEnterprise(null, params);
    dispatch({ type: AGENDA_MODEL_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: AGENDA_MODEL_LIST_FAILURE, payload: error });
  }
};

export const createAgendaModel = (formData) => ({
  action: async ({ dispatch }) => {
    dispatch({ type: AGENDA_MODEL_CREATE_REQUEST });
    try {
      const data = (await AgendaModel.insert(formData))?.data?.data;
      dispatch({ type: AGENDA_MODEL_CREATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: AGENDA_MODEL_CREATE_FAILURE, payload: error });
    }
  },
  rules: AgendaModelRules
});

export const updateAgendaModel = (id, formData) => ({
  action: async ({ dispatch }) => {
    dispatch({ type: AGENDA_MODEL_UPDATE_REQUEST });
    try {
      const data = await AgendaModel.updateById({ _id: id, ...formData });
      dispatch({ type: AGENDA_MODEL_UPDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: AGENDA_MODEL_UPDATE_FAILURE, payload: error });
    }
  },
  rules: AgendaModelRules
});

export const deleteAgendaModel = (id) => ({
  action: async ({ dispatch }) => {
    dispatch({ type: AGENDA_MODEL_DELETE_REQUEST });
    try {
      await AgendaModel.deleteById(id);
      dispatch({ type: AGENDA_MODEL_DELETE_SUCCESS, payload: id });
    } catch (error) {
      dispatch({ type: AGENDA_MODEL_DELETE_FAILURE, payload: error });
    }
  },
  rules: AgendaModelRules
});

export const agendaModelActions = {
  createAgendaModel,
  loadData: {
    action: async ({ dispatch, getState }) => {
      try {
        const isLoaded = getState().agendaModel?.isLoaded;
        if (isLoaded) {
          return;
        }
        dispatch({ type: AGENDA_MODEL_LIST_REQUEST });
        const data = await AgendaModel.getByEnterprise();
        dispatch({ type: AGENDA_MODEL_LIST_SUCCESS, payload: data });
      } catch (error) {
        console.error(error);
        dispatch({ type: AGENDA_MODEL_LIST_FAILURE, payload: error });
      }
    },
    rules: AgendaModelRules
  },
  refreshData: {
    action: async ({ dispatch, getState }) => {
      try {
        const isLoaded = getState().agendaModel?.isLoaded;
        if (!isLoaded) {
          return;
        }
        dispatch({ type: AGENDA_MODEL_LIST_REQUEST });
        const data = await AgendaModel.getByEnterprise();
        dispatch({ type: AGENDA_MODEL_LIST_SUCCESS, payload: data });
      } catch (error) {
        console.error(error);
        dispatch({ type: AGENDA_MODEL_LIST_FAILURE, payload: error });
      }
    },
    rules: AgendaModelRules
  },
  updateAgendaModel,
  deleteAgendaModel
};
